import { YLOPO_BASE_URL } from '../constants/listings'
import * as Sentry from '@sentry/browser'

export const buildPriceRangeParams = function (minPrice, maxPrice) {
  return `s[minPrice]=${minPrice}&s[maxPrice]=${maxPrice}`
}

const buildHBIdParam = clientId => {
  if (!clientId) {
    return ''
  }

  // Trailing ampersand only for this param in case absent clientId
  return `hbid=${clientId}&`
}

const buildZipParam = (index, zipcode) =>
  `s[locations][${index}][postalCode]=${zipcode}`

const buildWithLongLatParam = (lat, lng, radius) =>
  `s[circle][lat]=${lat}&s[circle][lng]=${lng}&s[circle][radius]=${radius}`

const buildOrderByParams = orderBy => `s[orderBy]=${orderBy}`

export const buildListingUrl = (clientId, listing) => {
  const hbidParam = buildHBIdParam(clientId)
  const zipParam = buildZipParam(0, listing.address.postalCode)

  return `${YLOPO_BASE_URL}/detail/${listing.id}?${hbidParam}${zipParam}`
}

export const buildMultiZipSearchUrl = (
  clientId,
  { markets, minPrice, maxPrice }
) => {
  const hbidParam = buildHBIdParam(clientId)
  const minMaxParam = buildPriceRangeParams(minPrice, maxPrice)

  const multiZipSearchParams = markets
    .map(({ zipcode }, index) => buildZipParam(index, zipcode))
    .join('&')

  return `${YLOPO_BASE_URL}?${hbidParam}${multiZipSearchParams}&${minMaxParam}`
}

export const buildSingleZipSearchUrl = (
  clientId,
  { zipcode, minPrice, maxPrice }
) => {
  const hbidParam = buildHBIdParam(clientId)
  const zipParam = buildZipParam(0, zipcode)
  const minMaxParam = buildPriceRangeParams(minPrice, maxPrice)

  return `${YLOPO_BASE_URL}?${hbidParam}${zipParam}&${minMaxParam}`
}

export const buildBasicSearchUrl = clientId => {
  const hbidParam = buildHBIdParam(clientId)

  return `${YLOPO_BASE_URL}?${hbidParam}`
}

export const buildViewAllSearchUrl = (
  clientId,
  { circle, minPrice, maxPrice, orderBy }
) => {
  const hbidParam = buildHBIdParam(clientId)
  const longLatParam = buildWithLongLatParam(
    circle.lat,
    circle.lng,
    circle.radius
  )
  const minMaxParam = buildPriceRangeParams(minPrice, maxPrice)
  const orderByParam = buildOrderByParams(orderBy)

  return `${YLOPO_BASE_URL}?${hbidParam}${longLatParam}&${minMaxParam}&${orderByParam}`
}

// remount is a function loaded via the ylopo widget, this is a way to see if it is present on the window.YLOPO_WIDGET object thus loaded properly
export const isYlopoLoaded = () => {
  if (typeof window.YLOPO_WIDGETS.remount === 'function') {
    return true
  }
  Sentry.captureMessage('Ylopo is down')
  return false
}
